import React from "react";
import { Alert, Box } from "@mui/material";
import type { FacilityNetworkViewModel } from "@utils/facilityNetworkView";
import { getFacilityHierarchyId } from "@utils/facilityUtils";
import FacilityNetworkFigmaHeading from "./FacilityNetworkFigmaHeading";
import FacilityNetworkParentFacilityCard from "./FacilityNetworkParentFacilityCard";
import FacilityNetworkSharedDataCard from "./FacilityNetworkSharedDataCard";
import {
  getImmediateParent,
  parentShortName,
} from "./facilityNetworkOverviewUtils";

type Props = {
  networkView: FacilityNetworkViewModel;
  onViewParentDetails: () => void;
  onNetworkMutated?: () => void;
};

export default function FacilityNetworkChildView({
  networkView,
  onViewParentDetails,
  onNetworkMutated,
}: Props) {
  const parent = getImmediateParent(networkView);
  const childId = getFacilityHierarchyId(networkView.selected);

  if (!parent) {
    return (
      <Alert severity="info">
        This facility is not linked to a parent yet. Select a child facility to see this view.
      </Alert>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, minWidth: 0, width: "100%" }}>
      <FacilityNetworkFigmaHeading
        title="Network"
        subtitle="Your parent facility relationship"
      />
      <FacilityNetworkParentFacilityCard
        parent={parent}
        childFacilityId={childId}
        onViewParentDetails={onViewParentDetails}
        onNetworkMutated={onNetworkMutated}
      />
      <FacilityNetworkSharedDataCard parentShortName={parentShortName(parent)} />
    </Box>
  );
}
